import { addEvent, extend, $, $$, targetContainerVisibility } from './helper-functions'

export class VideoBoxVariant2 {
  constructor (settings, selectors, classes) {
    this.settings = extend({
      defaultVideoRatio: 16 / 9,
      saveSettingWithCookie: true
    }, settings)

    this.selectors = extend({
      videoBox: '.video-box--variant-2',
      playButton: '.video-box__play',
      preview: '.video-box__preview-picture',
      player: '.video-box__player',
      consent: '.video-box__consent',
      consentButton: '.video-box__consent-button'
    }, selectors)

    this.classes = extend({
      setPreview: 'video-box--preview',
      setConsent: 'video-box--consent',
      setPlay: 'video-box--play',
      playerReady: 'video-box__player--ready'
    }, classes)

    this.$Cookies = require('js-cookie')
    this.videoBoxes = $$(this.selectors.videoBox)
  }

  init () {
    window.youtubeLoaded = false
    window.players = {}

    this.videoBoxes.forEach(videoBox => {
      const consentButton = $(this.selectors.consentButton, videoBox)
      const preview = $(this.selectors.preview, videoBox)

      if (consentButton && this.settings.saveSettingWithCookie === true && this.getCookie('ShowYoutube') === '1') {
        consentButton.checked = true
      }

      if (preview) {
        videoBox.classList.add(this.classes.setPreview)
      } else {
        this.goToVideo(videoBox, false)
      }
    })

    this.addEvents()
  }

  addEvents () {
    this.videoBoxes.forEach(videoBox => {
      const playButtons = $$(this.selectors.playButton, videoBox)
      const consentButtons = $$(this.selectors.consentButton, videoBox)

      playButtons.forEach(playButton => {
        addEvent(playButton, 'click', () => {
          const videoBox = playButton.closest(this.selectors.videoBox)

          this.goToVideo(videoBox)

          targetContainerVisibility(playButton)
        })
      })

      consentButtons.forEach(consentButton => {
        addEvent(consentButton, 'click', () => {
          const player = $(this.selectors.player, videoBox)

          if (videoBox.classList.contains(this.classes.setConsent)) {
            videoBox.classList.remove(this.classes.setConsent)
            videoBox.classList.add(this.classes.setPlay)

            if (this.settings.saveSettingWithCookie === true) {
              consentButtons.forEach(consentButton2 => {
                consentButton2.checked = true
              })

              this.videoBoxes.forEach(videoBox2 => {
                if (videoBox2.classList.contains(this.classes.setConsent) && videoBox2 !== videoBox) {
                  videoBox2.classList.remove(this.classes.setConsent)
                  videoBox2.classList.add(this.classes.setPreview)
                }
              })

              this.setCookie('ShowYoutube', '1')
            }

            this.showVideo(videoBox)

            playButtons.forEach(playButton => {
              playButton.setAttribute('aria-expanded', 'false')
              targetContainerVisibility(playButton)
            })
          } else {
            const players = $$(this.selectors.player, videoBox)

            consentButtons.forEach(ConsentButton2 => {
              if (ConsentButton2 !== consentButton) {
                ConsentButton2.checked = false
              }
            })

            this.videoBoxes.forEach(videoBox2 => {
              videoBox2.classList.remove(this.classes.setPlay)
              videoBox2.classList.add(this.classes.setConsent)
            })

            players.forEach(player2 => {
              if (player2 !== player) {
                player2.classList.remove(this.classes.playerReady)
              }
            })

            if (this.settings.saveSettingWithCookie === true) {
              this.setCookie('ShowYoutube', '0')
            }

            this.hideAllVideos()

            playButtons.forEach(playButton => {
              playButton.setAttribute('aria-expanded', 'true')
              targetContainerVisibility(playButton)
            })
          }
        })
      })
    })
  }

  goToVideo (videoBox, autoplay = true) {
    const playButton = $(this.selectors.playButton, videoBox)

    if (this.settings.saveSettingWithCookie === false) {
      videoBox.classList.remove(this.classes.setPreview)
      videoBox.classList.add(this.classes.setConsent)
      playButton.setAttribute('aria-expanded', 'true')
    } else {
      if (this.getCookie('ShowYoutube') === '1') {
        videoBox.classList.remove(this.classes.setPreview)
        videoBox.classList.add(this.classes.setPlay)
        playButton.setAttribute('aria-expanded', 'false')

        this.showVideo(videoBox, autoplay)
      } else {
        videoBox.classList.remove(this.classes.setPreview)
        videoBox.classList.add(this.classes.setConsent)
        playButton.setAttribute('aria-expanded', 'true')
      }
    }

    targetContainerVisibility(playButton)
  }

  showVideo (videoBox, autoplay = true) {
    const youtubeApi = $$('#youtube-api')

    if (youtubeApi.length === 0) {
      const tag = document.createElement('script')

      tag.setAttribute('id', 'youtube-api')
      tag.src = 'https://www.youtube.com/iframe_api'
      const firstScriptTag = document.getElementsByTagName('script')[0]
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

      window.onYouTubeIframeAPIReady = function () { // eslint-disable-line no-unused-vars
        window.youtubeLoaded = true
      }
    }

    if (window.youtubeLoaded === false) {
      const checkYoutube = window.setInterval(() => {
        if (window.youtubeLoaded === true) {
          this.showYoutube(videoBox, autoplay)
          clearInterval(checkYoutube)
        }
      }, 500)
    } else {
      this.showYoutube(videoBox, autoplay)
    }
  }

  hideAllVideos () {
    this.videoBoxes.forEach(videoBox => {
      const players = $$(this.selectors.player, videoBox)

      players.forEach(player => {
        while (player.firstChild) {
          player.removeChild(player.firstChild)
        }
      })
    })
  }

  showYoutube (videoBox, autoplay = true) {
    const videoPlayer = $(this.selectors.player, videoBox)
    const videoId = videoPlayer.dataset.videoId

    videoPlayer.classList.add(this.classes.playerReady)
    videoPlayer.innerHTML = '<div id="' + videoPlayer.getAttribute('id') + 'inner"></div>'

    window.players[videoPlayer.getAttribute('id') + 'inner'] = new YT.Player(videoPlayer.getAttribute('id') + 'inner', { // eslint-disable-line no-new, no-undef
      videoId,
      host: 'https://www.youtube-nocookie.com',
      playerVars: {
        rel: 0,
        showinfo: 0,
        ecver: 2
      },
      events: {
        onReady: function (event) {
          if (autoplay === true) {
            event.target.playVideo()
          }
        },
        onError: function (event) {
          event.target.destroy()
        }
      }
    })
  }

  stopVideo (videoBox) {
    const videoPlayer = $(this.selectors.player, videoBox)
    const playerId = videoPlayer.getAttribute('id') + 'inner'

    if (window.players[playerId]) {
      window.players[playerId].stopVideo()
    }
  }

  setCookie (name = '', value = '0') {
    this.$Cookies.set(name, value, {
      expires: 365,
      path: '/'
    })
  }

  getCookie (name) {
    return this.$Cookies.get(name)
  }
}

export default VideoBoxVariant2
